module.exports = __webpack_public_path__ + "41319d1eb1972c4c391a1e20a564e54e.woff2";